/* @fflow */
import React from 'react';
import { EntityTypesDownloadContainer } from 'containers/DownloadContainers';
import { Row } from 'components/UIKit/Flex';

const CasesToolbar = ({
  router: { location: { query } },
}): React.Element => (
  <Row>
    { !query.id
      && (
        <EntityTypesDownloadContainer
          customDataTestID="button-download-all-case-metadata"
          entityTypes={['case']}
          downloadAll
          >
        Download All Case Metadata
        </EntityTypesDownloadContainer>
      )
      }
    { query.id
      && (
        <EntityTypesDownloadContainer
          entityTypes={['case']}
          >
        Download All Case Metadata
        </EntityTypesDownloadContainer>
      )
      }
    { !query.id
      && (
        <EntityTypesDownloadContainer
          customDataTestID="button-download-all-clinical"
          entityTypes={['case']}
          options={{
            withChildren: true,
            category: 'clinical',
          }}
          downloadAll
          >
        Download All Clinical
        </EntityTypesDownloadContainer>
      )
      }
    { query.id
      && (
        <EntityTypesDownloadContainer
          entityTypes={['case']}
          options={{
            withChildren: true,
            category: 'clinical',
          }}
          >
        Download All Clinical
        </EntityTypesDownloadContainer>
      )
      }
  </Row>
);

export default CasesToolbar;
